import React from 'react';
import {
  ApplicationView,
  StartControllerScope,
  useController,
} from '@aha-app/mvc';
import Modal, { ModalHeader } from '../../utils/Modal';
import RoadmapImportModalController, {
  type RoadmapImportModalControllerProps,
  type RoadmapImportFormat,
} from './RoadmapImportModalController';
import customElementBoolAttr from '../../utils/customElementBoolAttr';
import { renderToStaticMarkup } from 'react-dom/server';

const iconForImage = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='70'
    height='70'
    fill='none'
    viewBox='0 0 70 70'
  >
    <path
      fill='#333'
      d='M52.186 18.223c2.879.016 4.438.143 5.455 1.16 1.161 1.162 1.161 3.033 1.161 6.772v17.69c0 3.74 0 5.61-1.16 6.772l-.112.106c-1.019.92-2.568 1.038-5.344 1.053l-1.317.003H19.132l-1.317-.003c-2.776-.015-4.325-.134-5.344-1.053l-.111-.106c-1.162-1.162-1.162-3.032-1.162-6.772v-17.69c0-3.623 0-5.491 1.056-6.66l.106-.112c1.017-1.017 2.575-1.145 5.455-1.16l1.317-.002H50.87zM19.132 20.02c-1.92 0-3.18.004-4.113.13-.88.118-1.196.315-1.387.505-.19.191-.387.506-.505 1.387-.126.932-.13 2.193-.13 4.113v17.69c0 1.92.004 3.18.13 4.113.118.88.315 1.195.505 1.386.191.19.507.387 1.387.506.932.125 2.193.128 4.113.128H50.87c1.92 0 3.18-.003 4.113-.128.88-.119 1.195-.316 1.386-.506.19-.191.387-.506.505-1.386.126-.932.13-2.192.13-4.113v-17.69c0-1.92-.004-3.18-.13-4.113-.118-.88-.315-1.196-.505-1.387-.191-.19-.506-.387-1.386-.506-.932-.125-2.193-.129-4.113-.129zm10.65 8.375c.678-.016 1.185.34 1.603.777.404.422.834 1.04 1.342 1.764l6.735 9.618c.542.773 1.004 1.428 1.268 1.968.265.541.45 1.211.05 1.852-.38.605-1.044.791-1.662.868-.634.08-1.483.071-2.512.064l-12.67-.095c-.959-.007-1.755-.012-2.354-.096-.59-.083-1.215-.27-1.587-.84-.393-.603-.258-1.245-.033-1.779.221-.523.62-1.158 1.082-1.9l5.935-9.523c.466-.747.86-1.385 1.24-1.826.394-.458.883-.837 1.563-.852m14.078 6.413c.557-.015.962.285 1.263.596.29.301.598.736.946 1.222l3.262 4.563c.447.626.835 1.164 1.065 1.612.228.444.421 1.026.116 1.614s-.893.765-1.388.834c-.498.07-1.162.063-1.931.058l-3.067-.023a.75.75 0 0 1 .01-1.5l3.069.023c.82.006 1.35.007 1.712-.043a1.3 1.3 0 0 0 .238-.053 1.3 1.3 0 0 0-.093-.225c-.167-.325-.475-.758-.952-1.425l-3.262-4.563c-.376-.526-.61-.85-.804-1.053a1 1 0 0 0-.144-.125 1 1 0 0 0-.134.133c-.183.212-.4.55-.747 1.095a.75.75 0 0 1-1.266-.806c.321-.504.606-.954.88-1.27.283-.328.67-.649 1.227-.664m-14.044-4.913c-.066.001-.19.016-.46.33-.286.333-.61.85-1.104 1.641l-5.934 9.523c-.492.789-.81 1.304-.973 1.69-.078.185-.097.29-.1.34 0 .03.003.032.006.036.004.006.063.108.54.175.476.067 1.153.073 2.157.08l12.67.096c1.074.008 1.802.012 2.314-.052.25-.031.4-.074.486-.113.073-.033.087-.057.09-.063.001-.001.005.001.002-.032-.005-.056-.031-.168-.128-.365-.2-.408-.575-.947-1.148-1.766l-6.736-9.617c-.537-.767-.891-1.27-1.197-1.59-.29-.305-.418-.315-.485-.313m10.433-5.688a4.13 4.13 0 1 1 0 8.259 4.13 4.13 0 0 1 0-8.259m0 1.5a2.63 2.63 0 1 0 0 5.258 2.63 2.63 0 0 0 0-5.258'
    />
  </svg>
);

const iconForRecords = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='70'
    height='70'
    fill='none'
    viewBox='0 0 70 70'
  >
    <path
      fill='#333'
      d='M44.685 19.286c2.828 0 4.243 0 5.121.879.644.644.815 1.575.861 3.14 1.564.046 2.495.216 3.14.86.643.644.814 1.575.86 3.14 1.564.046 2.495.216 3.14.86.878.879.878 2.293.878 5.121v11.428l-.002.996c-.012 2.177-.108 3.356-.877 4.125s-1.947.865-4.125.877l-.996.002h-27.37l-.996-.002c-2.022-.011-3.183-.095-3.954-.722l-.171-.155c-.644-.644-.814-1.576-.86-3.14-1.431-.043-2.333-.187-2.97-.705l-.17-.155c-.644-.644-.814-1.576-.86-3.14-1.431-.043-2.333-.187-2.97-.705l-.17-.155c-.769-.769-.865-1.948-.877-4.125l-.002-.996V25.286c0-2.651 0-4.06.724-4.95l.155-.171c.769-.769 1.947-.865 4.125-.877l.996-.002zm10 10v11.428l-.002.996c-.012 2.177-.108 3.356-.877 4.125s-1.947.865-4.125.877l-.996.002h-27.37l-.182-.001c.014.416.036.758.076 1.053.082.617.208.747.257.797.05.049.18.174.797.257.67.09 1.587.094 3.052.094h27.37c1.465 0 2.383-.004 3.052-.094.616-.083.747-.208.797-.258.049-.049.175-.18.258-.796.09-.67.093-1.587.093-3.052V33.286c0-1.465-.004-2.383-.093-3.052-.083-.617-.21-.747-.258-.797-.05-.049-.18-.174-.797-.257-.294-.04-.637-.063-1.053-.076zm-4-4v11.428l-.002.996c-.012 2.177-.108 3.356-.877 4.125s-1.947.865-4.125.877l-.996.002h-27.37l-.182-.001c.014.416.036.758.076 1.053.082.617.208.747.257.797.05.049.18.174.797.257.67.09 1.587.094 3.052.094h27.37c1.465 0 2.383-.004 3.052-.094.616-.083.747-.208.797-.258.049-.049.175-.18.258-.796.09-.67.093-1.587.093-3.052V29.286c0-1.465-.004-2.383-.093-3.052-.083-.617-.21-.747-.258-.797-.05-.049-.18-.174-.797-.257-.294-.04-.637-.063-1.053-.076zm-34.364-4.2v19.826q.449.003.994.002h27.37c1.465 0 2.383-.004 3.052-.094.616-.083.747-.208.797-.258.049-.049.175-.18.258-.796.09-.67.093-1.587.093-3.052V25.286c0-1.465-.004-2.383-.093-3.052-.083-.617-.21-.747-.258-.797-.05-.049-.18-.174-.797-.257-.67-.09-1.587-.094-3.052-.094H16.321m18.931 13.417a.75.75 0 1 1 0 1.5H21.13a.75.75 0 0 1 0-1.5z'
    />
  </svg>
);

const iconForEmbedded = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='70'
    height='70'
    fill='none'
    viewBox='0 0 70 70'
  >
    <g fill='#333' clipPath='url(#a)'>
      <path
        d='M68.065 41.79h-55.02v-.683h55.02zm.847-11.623h-56.2v-.682h56.2z'
        opacity='.5'
      />
      <path d='M33.723 20.256h.952v41.703h-.952z' />
      <path d='M17.982 36.803c0-.449 0-.673.14-.813s.364-.14.813-.14l31.481.001c.45 0 .674 0 .813.14.14.139.14.363.14.812v.089c0 .886 0 1.33-.276 1.457-.276.128-.614-.158-1.291-.73l-.315-.267c-.132-.11-.198-.166-.277-.195-.08-.03-.166-.03-.338-.03H20.556c-.167 0-.251 0-.328.028-.078.027-.142.08-.272.185l-.421.342c-.673.547-1.01.82-1.281.69-.272-.128-.272-.562-.272-1.429zM22.129 46.057c0-.43 0-.644.125-.78l.029-.029c.136-.125.348-.125.772-.125l15.192-.002c.4 0 .6 0 .733.112q.03.026.056.056c.112.133.112.333.112.733v.109c0 .8 0 1.199-.2 1.341a.5.5 0 0 1-.206.083c-.244.035-.52-.254-1.072-.831-.11-.117-.166-.175-.235-.21a1 1 0 0 0-.07-.03c-.074-.026-.154-.026-.315-.026l-12.718.002c-.178 0-.267 0-.348.031l-.027.011c-.08.036-.143.098-.27.224-.633.629-.95.944-1.224.858a.5.5 0 0 1-.08-.033c-.254-.135-.254-.588-.254-1.494' />
      <rect
        width='5.124'
        height='5.124'
        x='46.892'
        y='29.881'
        rx='1'
        transform='rotate(-45 46.892 29.881)'
      />
      <path d='M29.533 19.126h9.332L34.2 23.792z' />
    </g>
    <rect
      width='45.805'
      height='31.76'
      x='12.098'
      y='19.12'
      stroke='#333'
      strokeWidth='1.8'
      rx='2.274'
    />
    <defs>
      <clipPath id='a'>
        <rect
          width='47.605'
          height='33.56'
          x='11.198'
          y='18.22'
          fill='#fff'
          rx='3.174'
        />
      </clipPath>
    </defs>
  </svg>
);

function iconToDataURI(rawIcon) {
  const svgString = renderToStaticMarkup(rawIcon);
  return `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`;
}

const RoadmapImportModal: React.FC<
  RoadmapImportModalControllerProps
> = props => {
  const controller = useController(RoadmapImportModalController);
  const { importOption } = controller.state;

  const handleOptionSelect = (option: RoadmapImportFormat) => {
    controller.actionSelectOption(option);
  };

  return (
    <Modal onClose={controller.actionClose}>
      <div style={{ width: '500px' }}>
        <ModalHeader
          onClose={() => controller.actionClose()}
          modalTitle='Import roadmap'
        />

        <div style={{ padding: '20px' }}>
          <p>Choose how to import this roadmap:</p>

          {props.bookmarkInfo.availableFormats.includes('records') && (
            <aha-visual-selection
              src={iconToDataURI(iconForRecords)}
              selected={customElementBoolAttr(importOption === 'records')}
              onClick={() => handleOptionSelect('records')}
            >
              <b slot='title'>Import as records</b>
              <p slot='description'>
                Imports the roadmap with interactive record cards
              </p>
            </aha-visual-selection>
          )}
          {props.bookmarkInfo.availableFormats.includes('image') && (
            <aha-visual-selection
              src={iconToDataURI(iconForImage)}
              selected={customElementBoolAttr(importOption === 'image')}
              onClick={() => handleOptionSelect('image')}
            >
              <b slot='title'>Import as image</b>
              <p slot='description'>Adds an image of the current roadmap</p>
            </aha-visual-selection>
          )}
          {props.bookmarkInfo.availableFormats.includes('embedded') && (
            <aha-visual-selection
              src={iconToDataURI(iconForEmbedded)}
              selected={customElementBoolAttr(importOption === 'embedded')}
              onClick={() => handleOptionSelect('embedded')}
            >
              <b slot='title'>Import as view</b>
              <p slot='description'>Embeds a dynamic view of the roadmap</p>
            </aha-visual-selection>
          )}
        </div>

        <aha-modal-footer>
          <aha-button
            kind='secondary'
            type='button'
            onClick={() => controller.actionClose()}
          >
            Cancel
          </aha-button>
          <aha-button
            kind='primary'
            type='button'
            disabled={customElementBoolAttr(!importOption)}
            onClick={() => {
              controller.actionConfirm().catch(console.error);
            }}
          >
            Import
          </aha-button>
        </aha-modal-footer>
      </div>
    </Modal>
  );
};

export default StartControllerScope(
  RoadmapImportModalController,
  ApplicationView(RoadmapImportModal)
);
